export default "__VITE_ASSET__bebcb93f__"